// Pippie - a hand-drawn cat mascot, imported from the Claude Design project
// "Pippie pet design" (Pippie.dc.html). Two states: idle (home / shop) and
// happy (win modal). Assembled from shared parts exactly as the design does;
// the animation classes (pip-cat / pip-tail / pip-eyes) are styled in style.css.

const PIP_DEFS = `
  <defs>
    <linearGradient id="gBody" x1="0" y1="0" x2="0.35" y2="1">
      <stop offset="0" stop-color="#a2814f"/><stop offset="0.5" stop-color="#7f603c"/><stop offset="1" stop-color="#59401f"/>
    </linearGradient>
    <linearGradient id="gHead" x1="0.1" y1="0" x2="0.3" y2="1">
      <stop offset="0" stop-color="#ab8850"/><stop offset="0.5" stop-color="#896840"/><stop offset="1" stop-color="#63482a"/>
    </linearGradient>
    <linearGradient id="gOrange" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#e59f5e"/><stop offset="1" stop-color="#bd7233"/>
    </linearGradient>
    <linearGradient id="gWhite" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#fffdf8"/><stop offset="1" stop-color="#e6ddca"/>
    </linearGradient>
    <radialGradient id="gEar" cx="0.5" cy="0.35" r="0.85">
      <stop offset="0" stop-color="#f0b7af"/><stop offset="1" stop-color="#c9847c"/>
    </radialGradient>
    <radialGradient id="gEye" cx="0.42" cy="0.3" r="0.9">
      <stop offset="0" stop-color="#dbe491"/><stop offset="0.45" stop-color="#a6b656"/><stop offset="0.82" stop-color="#6d883a"/><stop offset="1" stop-color="#4c6227"/>
    </radialGradient>
    <linearGradient id="gNose" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#eeadb2"/><stop offset="1" stop-color="#d2848c"/>
    </linearGradient>
    <radialGradient id="gVig" cx="0.5" cy="0.4" r="0.75">
      <stop offset="0.55" stop-color="rgba(40,26,12,0)"/><stop offset="1" stop-color="rgba(40,26,12,0.32)"/>
    </radialGradient>
    <filter id="soft" x="-30%" y="-30%" width="160%" height="160%"><feGaussianBlur stdDeviation="4"/></filter>
  </defs>`;

const PIP_BODY = `
  <ellipse cx="130" cy="324" rx="94" ry="15" fill="#33261a" opacity="0.16" filter="url(#soft)"/>
  <!-- ears -->
  <path d="M70,90 L52,22 Q50,13 61,17 L124,66 Z" fill="url(#gHead)" stroke="#2b2013" stroke-width="3" stroke-linejoin="round"/>
  <path d="M190,90 L208,22 Q210,13 199,17 L136,66 Z" fill="url(#gHead)" stroke="#2b2013" stroke-width="3" stroke-linejoin="round"/>
  <path d="M75,84 L64,34 L112,66 Z" fill="url(#gEar)"/>
  <path d="M185,84 L196,34 L148,66 Z" fill="url(#gEar)"/>
  <path d="M70,72 L66,44 L86,62 Z" fill="#fdf6ea" opacity="0.8"/>
  <path d="M190,72 L194,44 L174,62 Z" fill="#fdf6ea" opacity="0.8"/>
  <!-- body -->
  <path d="M62,170 C33,198 30,260 55,306 C68,328 100,334 130,334 C160,334 192,328 205,306 C230,260 227,198 198,170 C179,151 150,151 130,151 C110,151 81,151 62,170 Z" fill="url(#gBody)" stroke="#2b2013" stroke-width="3"/>
  <!-- orange calico patch on body -->
  <path d="M170,186 C198,192 210,228 198,266 C184,258 172,232 168,204 C167,196 168,188 170,186 Z" fill="url(#gOrange)" opacity="0.92"/>
  <!-- body tabby stripes left -->
  <g fill="#33241a" opacity="0.72">
    <path d="M66,196 C60,220 62,250 72,278 C78,252 78,224 76,200 Z"/>
    <path d="M92,182 C88,210 88,244 96,276 C102,246 100,214 100,186 Z"/>
    <path d="M196,198 C202,222 200,252 190,280 C184,254 184,226 186,202 Z"/>
  </g>
  <!-- head -->
  <ellipse cx="130" cy="118" rx="77" ry="71" fill="url(#gHead)" stroke="#2b2013" stroke-width="3"/>
  <!-- orange patch over right eye/ear -->
  <path d="M150,56 C178,58 199,80 201,112 C190,120 168,118 156,102 C148,86 146,68 150,56 Z" fill="url(#gOrange)" opacity="0.9"/>
  <!-- head tabby stripes -->
  <g fill="#33241a" opacity="0.78">
    <path d="M130,50 L124,112 L136,112 Z"/>
    <path d="M107,58 L106,108 L114,106 Z"/>
    <path d="M153,58 L154,108 L146,106 Z"/>
    <path d="M64,104 C74,108 84,114 92,122 C82,124 70,120 60,114 Z"/>
    <path d="M196,104 C186,108 176,114 168,122 C178,124 190,120 200,114 Z"/>
    <path d="M60,132 C72,134 84,138 92,144 C82,148 70,146 58,142 Z"/>
    <path d="M200,132 C188,134 176,138 168,144 C178,148 190,146 202,142 Z"/>
  </g>
  <!-- white chest bib -->
  <path d="M106,164 C93,198 90,252 100,302 C112,324 148,324 160,302 C170,252 167,198 154,164 C144,150 116,150 106,164 Z" fill="url(#gWhite)"/>
  <!-- cheek ruff scallops -->
  <path d="M104,158 q-9,10 -3,20 q-10,-2 -12,10 q-8,-4 -14,4 q4,-26 29,-34 Z" fill="url(#gWhite)"/>
  <path d="M156,158 q9,10 3,20 q10,-2 12,10 q8,-4 14,4 q-4,-26 -29,-34 Z" fill="url(#gWhite)"/>
  <!-- front legs -->
  <path d="M96,250 C89,250 85,257 85,268 L85,308 C85,320 96,326 108,326 C120,326 126,318 126,308 L126,268 C126,257 121,250 113,250 Z" fill="url(#gWhite)" stroke="#d3c6ac" stroke-width="1.5"/>
  <path d="M147,250 C140,250 134,257 134,268 L134,308 C134,318 140,326 152,326 C164,326 175,320 175,308 L175,268 C175,257 171,250 164,250 Z" fill="url(#gWhite)" stroke="#d3c6ac" stroke-width="1.5"/>
  <g stroke="#cbbda2" stroke-width="1.4" fill="none" stroke-linecap="round">
    <path d="M98,318 L98,308"/><path d="M106,320 L106,309"/><path d="M114,318 L114,308"/>
    <path d="M147,318 L147,308"/><path d="M155,320 L155,309"/><path d="M163,318 L163,308"/>
  </g>
  <!-- tail wrapping to the front -->
  <g class="pip-tail">
    <path d="M196,280 C222,290 227,314 210,328 C182,345 137,343 109,331 C94,325 95,310 110,310 C133,314 171,314 189,300 C197,292 194,282 196,280 Z" fill="url(#gBody)" stroke="#2b2013" stroke-width="2.6"/>
    <g fill="#33241a" opacity="0.72">
      <path d="M148,315 q7,11 3,22 q-9,-1 -11,-9 q-3,-9 8,-13 Z"/>
      <path d="M174,309 q9,9 6,20 q-10,0 -13,-8 q-3,-8 7,-12 Z"/>
      <path d="M197,297 q9,7 8,17 q-9,2 -13,-5 q-4,-8 5,-12 Z"/>
    </g>
    <path d="M110,309 q-8,1 -9,7 q11,3 18,-3 Z" fill="url(#gWhite)"/>
  </g>`;

const PIP_MUZZLE = `
  <!-- white muzzle -->
  <path d="M99,134 C95,158 110,178 130,180 C150,178 165,158 161,134 C150,148 110,148 99,134 Z" fill="url(#gWhite)"/>
  <!-- whisker dots -->
  <g fill="#c9b99e"><circle cx="110" cy="150" r="1.3"/><circle cx="108" cy="157" r="1.3"/><circle cx="115" cy="155" r="1.3"/><circle cx="150" cy="150" r="1.3"/><circle cx="152" cy="157" r="1.3"/><circle cx="145" cy="155" r="1.3"/></g>
  <!-- nose -->
  <path d="M120,145 L140,145 Q143,146 141,150 L131,159 Q130,160 129,159 L119,150 Q117,146 120,145 Z" fill="url(#gNose)" stroke="#b06d72" stroke-width="1"/>
  <path d="M124,150 q6,3 12,0" stroke="#b06d72" stroke-width="0.9" fill="none" opacity="0.6"/>
  <!-- mouth -->
  <path d="M130,159 L130,166" stroke="#7a5f47" stroke-width="1.8" fill="none" stroke-linecap="round"/>
  <path d="M130,166 Q117,178 105,171" stroke="#7a5f47" stroke-width="1.8" fill="none" stroke-linecap="round"/>
  <path d="M130,166 Q143,178 155,171" stroke="#7a5f47" stroke-width="1.8" fill="none" stroke-linecap="round"/>
  <!-- whiskers -->
  <g stroke="#fffdf8" stroke-width="1.5" fill="none" stroke-linecap="round" opacity="0.92">
    <path d="M112,150 Q84,146 58,152"/><path d="M112,156 Q86,158 62,168"/><path d="M113,162 Q90,168 70,182"/>
    <path d="M148,150 Q176,146 202,152"/><path d="M148,156 Q174,158 198,168"/><path d="M147,162 Q170,168 190,182"/>
  </g>`;

const PIP_VIG = `<ellipse cx="130" cy="130" rx="100" ry="120" fill="url(#gVig)" pointer-events="none"/>`;

const PIP_EYES_OPEN = `
  <g class="pip-eyes">
    <path d="M84,116 C88,104 104,102 116,108 C124,112 124,126 116,132 C104,138 88,134 84,124 Z" fill="#241a12"/>
    <path d="M176,116 C172,104 156,102 144,108 C136,112 136,126 144,132 C156,138 172,134 176,124 Z" fill="#241a12"/>
    <ellipse cx="103" cy="118" rx="13" ry="13.5" fill="url(#gEye)"/>
    <ellipse cx="157" cy="118" rx="13" ry="13.5" fill="url(#gEye)"/>
    <ellipse cx="103" cy="119" rx="5.5" ry="11" fill="#1c140c"/>
    <ellipse cx="157" cy="119" rx="5.5" ry="11" fill="#1c140c"/>
    <circle cx="99" cy="113" r="3.3" fill="#fff" opacity="0.92"/>
    <circle cx="153" cy="113" r="3.3" fill="#fff" opacity="0.92"/>
    <circle cx="106" cy="124" r="1.6" fill="#fff" opacity="0.5"/>
    <circle cx="160" cy="124" r="1.6" fill="#fff" opacity="0.5"/>
  </g>`;

const PIP_CHEEKS = `
  <ellipse cx="95" cy="140" rx="12" ry="8" fill="#f0929a" opacity="0.4"/>
  <ellipse cx="165" cy="140" rx="12" ry="8" fill="#f0929a" opacity="0.4"/>`;

const PIP_EYES_HAPPY = `
  <g fill="none" stroke="#241a12" stroke-width="5.5" stroke-linecap="round">
    <path d="M88,122 Q103,106 118,122"/>
    <path d="M142,122 Q157,106 172,122"/>
  </g>
  <path d="M76,110 l2,-7 l2,7 l7,2 l-7,2 l-2,7 l-2,-7 l-7,-2 Z" fill="#ffd45c"/>`;

const PIP_MUZZLE_HAPPY = `
  <path d="M99,134 C95,158 110,178 130,180 C150,178 165,158 161,134 C150,148 110,148 99,134 Z" fill="url(#gWhite)"/>
  <g fill="#c9b99e"><circle cx="110" cy="150" r="1.3"/><circle cx="108" cy="157" r="1.3"/><circle cx="115" cy="155" r="1.3"/><circle cx="150" cy="150" r="1.3"/><circle cx="152" cy="157" r="1.3"/><circle cx="145" cy="155" r="1.3"/></g>
  <path d="M120,145 L140,145 Q143,146 141,150 L131,159 Q130,160 129,159 L119,150 Q117,146 120,145 Z" fill="url(#gNose)" stroke="#b06d72" stroke-width="1"/>
  <path d="M130,159 L130,163" stroke="#7a5f47" stroke-width="1.8" fill="none" stroke-linecap="round"/>
  <!-- open happy smile -->
  <path d="M108,164 Q130,192 152,164 Q130,174 108,164 Z" fill="#8a4a46"/>
  <path d="M122,172 Q130,185 138,172 Q130,177 122,172 Z" fill="#ea929b"/>
  <path d="M108,164 Q130,171 152,164" stroke="#7a5f47" stroke-width="1.8" fill="none" stroke-linecap="round"/>
  <g stroke="#fffdf8" stroke-width="1.5" fill="none" stroke-linecap="round" opacity="0.92">
    <path d="M112,150 Q84,146 58,152"/><path d="M112,156 Q86,158 62,168"/>
    <path d="M148,150 Q176,146 202,152"/><path d="M148,156 Q174,158 198,168"/>
  </g>`;

const PIP_PAW = `
  <g transform="rotate(-6 200 175)">
    <path d="M181,206 C173,182 180,150 199,140 C217,135 227,150 222,170 C218,188 207,204 197,216 Z" fill="url(#gWhite)" stroke="#d3c6ac" stroke-width="1.5"/>
    <g stroke="#cbbda2" stroke-width="1.4" fill="none" stroke-linecap="round"><path d="M205,148 L211,152"/><path d="M200,155 L207,159"/><path d="M196,163 L203,167"/></g>
  </g>`;

const SVG_OPEN = `<svg viewBox="0 0 260 348" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:auto;display:block;overflow:visible;">`;

/** Idle Pippie: sits and blinks. Home screen + shop preview. */
export const PIPPIE_IDLE = `${SVG_OPEN}
  ${PIP_DEFS}
  <g class="pip-cat">
    ${PIP_BODY}
    ${PIP_MUZZLE}
    ${PIP_EYES_OPEN}
    ${PIP_VIG}
  </g>
</svg>`;

/** Happy Pippie: waving paw, big smile, sparkle. Win modal. */
export const PIPPIE_HAPPY = `${SVG_OPEN}
  ${PIP_DEFS}
  <g class="pip-cat">
    ${PIP_BODY}
    ${PIP_PAW}
    ${PIP_MUZZLE_HAPPY}
    ${PIP_CHEEKS}
    ${PIP_EYES_HAPPY}
    ${PIP_VIG}
  </g>
</svg>`;
